import React, { useState } from "react";
import { Calculator, Minus, Plus } from "lucide-react";
import { calcApi, normalize } from "@/lib/customCalc";
import { isoDate } from "@/lib/format";
import { getErrorMessage } from "@/lib/api";
import CustomResultDisplay from "@/components/CustomResultDisplay";
import { Field } from "./StepBasics";

export function StudentInputs({ classes, counts, setCounts, prefix }) {
  const setC = (k, v) => setCounts((p) => ({ ...p, [k]: Math.max(0, Math.min(9999, v)) }));
  return (
    <div className="space-y-2">
      {classes.map((c) => {
        const v = parseInt(counts[c.key] || 0, 10) || 0;
        return (
          <div key={c.key} className="rounded-xl bg-white border border-thali-turmeric/30 p-2 pl-3 flex items-center justify-between gap-2" style={{ borderLeft: `5px solid ${c.color}` }}>
            <span className="text-sm font-semibold truncate">{c.emoji} {c.name}</span>
            <div className="flex items-center gap-1 shrink-0">
              <button onClick={() => setC(c.key, v - 1)} className="w-11 h-11 rounded-lg bg-thali-cream" aria-label="decrease" data-testid={`${prefix}-minus-${c.key}`}><Minus className="w-4 h-4 mx-auto" /></button>
              <input value={v} inputMode="numeric" onChange={(e) => setC(c.key, parseInt(e.target.value.replace(/\D/g, "") || 0, 10))}
                className="w-14 h-11 text-center font-num font-bold text-xl bg-transparent border-b-2 border-thali-turmeric/40" data-testid={`${prefix}-input-${c.key}`} />
              <button onClick={() => setC(c.key, v + 1)} className="w-11 h-11 rounded-lg bg-thali-green text-white" aria-label="increase" data-testid={`${prefix}-plus-${c.key}`}><Plus className="w-4 h-4 mx-auto" /></button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function StepPreview({ cfg, b }) {
  const [date, setDate] = useState(isoDate(new Date()));
  const [counts, setCounts] = useState({});
  const [result, setResult] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setErr(""); setBusy(true);
    try { setResult(await calcApi.preview(normalize(cfg), date, counts)); }
    catch (e) { setResult(null); setErr(getErrorMessage(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="space-y-4" data-testid="step-preview">
      <Field label={b("date")}>
        <input type="date" className="input-thali" value={date} onChange={(e) => { setDate(e.target.value); setResult(null); }} data-testid="b-preview-date" />
      </Field>
      <StudentInputs classes={cfg.classes} counts={counts} setCounts={(f) => { setCounts(f); setResult(null); }} prefix="b-prev" />
      {err && <div className="text-red-600 text-sm bg-red-50 rounded-lg p-2" data-testid="b-preview-error">{err}</div>}
      <button onClick={run} disabled={busy} className="btn-3d-saffron w-full text-lg" data-testid="b-preview-calc"><Calculator className="w-5 h-5" /> {busy ? "…" : b("calculate")}</button>
      <CustomResultDisplay result={result} b={b} testid="b-preview-result" />
    </div>
  );
}
